import React from "react"
import FieldDate_Editable from "../../../../../../generic/datetime/date/render/editable/editable"
import DatetimeUtils from "../../../../../../../gd/utils/datetime-utils"
import formatDate from "../../../../../../../gd/format/date"

export default class FieldTaskDeadline_Editable extends FieldDate_Editable {

    renderValue() {
        const value = this.props.field.getViewValue(this.props.model)
        if (!value) {
            return null
        }

        const isTaskOpen = gd.const.systemStatus.isOpen(this.props.model.systemStatus)
        const isPastdue  = DatetimeUtils.isBeforeToday(value)

        const classes = Classes("txt-truncate cursor-default", {
            'ui5-color-red': isTaskOpen && isPastdue,
        })

        return (
            <div className={classes}>
                {formatDate(DatetimeUtils.dateToMoment(value))}
            </div>
        )
    }
}
